<!-- 配件销售统计 -->
<template>
    <div class="searchAp-ctn" id="packSaleList">
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                style="width: 100%; margin-bottom: 0"
            >
                <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120px" prop="ShopName" label="店铺"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120px" prop="CusName" label="客户"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="OrderAmount" label="订单总额"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="PayTypeName" label="支付方式"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="ShipTypeName" label="发货方式"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="180px" prop="Remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="SName" label="业务员"></el-table-column>
                <el-table-column show-overflow-tooltip width="145px" prop="CreateTime" label="创建时间"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        PackId: String
    },
    data() {
        return {
            loading: false,
            tableData: []
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetExpPackOrderDatas',
                    data: { PackId: this.PackId },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },

        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>
<style lang="less">
#packSaleList {
    padding: 15px 0;
}
</style>
